import { useCallback, useEffect } from "react";
import { SERVER_SENT_EVENT_KEY } from "../constants/serverSentEvents/serverSentEvents.js";
const useServerSentEvent = (name, type, callback, disabled = false) => {
  const handleUpdate = useCallback(
    (event) => {
      var _a, _b, _c, _d;
      if (name !== ((_b = (_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.meta) == null ? void 0 : _b.resourceType) || type !== ((_d = (_c = event == null ? void 0 : event.detail) == null ? void 0 : _c.meta) == null ? void 0 : _d.eventType))
        return;
      callback(event.detail.data);
    },
    [callback, name, type]
  );
  useEffect(() => {
    if (!disabled)
      document.addEventListener(SERVER_SENT_EVENT_KEY, handleUpdate);
    return () => {
      document.removeEventListener(SERVER_SENT_EVENT_KEY, handleUpdate);
    };
  }, [callback, name, type, handleUpdate, disabled]);
};
export {
  useServerSentEvent
};
